export default function CodeOfConduct() {
  return (
    <div data-testid="conduct-page" className="pt-32 pb-24">
      <section className="max-w-[900px] mx-auto px-6 lg:px-12">
        <p className="label-overline text-zinc-500">Studio principles</p>
        <h1 className="font-serif text-5xl md:text-6xl tracking-tighter font-light mt-4 leading-[0.9]">
          Code of conduct.
        </h1>
        <p className="text-zinc-500 mt-3 text-sm">Effective: December 2025 · Applies to all employees, freelancers, talents and clients.</p>

        <div className="mt-12 space-y-10 text-zinc-700 leading-relaxed">
          <Section title="1. Why this exists">
            <p>
              The fashion and modeling industries have, for decades, normalised practices that
              hurt the people they depend on. Ege Models exists in part to be different.
              This Code is the floor — never the ceiling — of how we work.
            </p>
          </Section>

          <Section title="2. Safety on set & off">
            <ul className="list-disc list-inside space-y-2">
              <li>No nudity or partial nudity is ever required for casting, testing or first meetings.</li>
              <li>Talents under 18 are accompanied by a parent or guardian on set; never tested or shot privately.</li>
              <li>An agency representative is reachable by phone for the duration of every shoot.</li>
              <li>Talents have an absolute right to leave any set, casting, or interaction that feels unsafe — without penalty.</li>
            </ul>
          </Section>

          <Section title="3. Consent & dignity">
            <ul className="list-disc list-inside space-y-2">
              <li>Image rights are negotiated explicitly per booking. We do not assign blanket usage to anyone.</li>
              <li>No photoshopping a talent's body shape or skin without their written approval of the final image.</li>
              <li>No castings or shoots involve alcohol or drugs at any point.</li>
              <li>Clients and crew may not contact talents directly without our involvement during a booking.</li>
            </ul>
          </Section>

          <Section title="4. Mental & physical health">
            <ul className="list-disc list-inside space-y-2">
              <li>We do not require, suggest, or reward weight loss or dietary changes. Ever.</li>
              <li>We provide access to industry-experienced mental health resources for our roster.</li>
              <li>Realistic schedules. No back-to-back overnight shoots, no working sick.</li>
            </ul>
          </Section>

          <Section title="5. Equity & inclusion">
            <ul className="list-disc list-inside space-y-2">
              <li>We sign and represent talents of every background, body shape, age and ability.</li>
              <li>We ask the same of our clients: shoots that align with discriminatory creative direction will be declined.</li>
              <li>Pay parity is non-negotiable — comparable bookings pay comparable rates regardless of identity.</li>
            </ul>
          </Section>

          <Section title="6. Money & transparency">
            <ul className="list-disc list-inside space-y-2">
              <li>Talents receive a clear breakdown of every placement fee — including taxes, expenses and our commission, on every job.</li>
              <li>No hidden costs, no surprise deductions — anything charged back to a talent is agreed in writing first.</li>
            </ul>
          </Section>

          <Section title="7. Reporting & accountability">
            <p>
              Concerns of any kind can be raised privately to <a href="mailto:info@egemodels.com" className="link-underline">info@egemodels.com</a>.
              All reports are reviewed by a non-management partner within 48 hours.
              Retaliation against anyone who reports in good faith is grounds for immediate termination.
            </p>
          </Section>

          <Section title="8. The line">
            <p>
              We will lose business before we will compromise this Code. If we have ever fallen short of any of the above,
              we want to hear it — and to make it right. This document is reviewed annually.
            </p>
          </Section>
        </div>
      </section>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div>
      <h2 className="font-serif text-2xl mb-3 text-black">{title}</h2>
      {children}
    </div>
  );
}
